import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, Metamodel, IModel, ImportExportSettings } from 'shell-models-lib';

import { TabularSinkAdapter } from 'app/model/adapters/activities/copysink/tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { CopySinkAdapter } from './copysink.adapter';
import { TeradataSink } from 'app/model/pipeline/copysink/teradata.copysink';
import { ValueAdapter } from '../../value.adapter';
import { toParameterObject, toParameterClass } from '../../linkedservices/parameter-config.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TeradataSink),
    asynchronous: true,
    adapts: {
        type: '*',
        preCopyScript: '*',
        importSettings: '*'
    }
})
export class TeradataSinkAdapter extends CopySinkAdapter<TeradataSink, Model.TeradataSink> {
    protected model(): IModel {
        return TeradataSink.MODEL;
    }

    protected override async _toResource(model: TeradataSink): Promise<Model.TeradataSink> {
        const result: Model.TeradataSink = {
            type: this.model().name
        };
        TabularSinkAdapter.toSinkResource(model, result);
        if (model.importSettings != null) {
            result.importSettings = {
                type: 'TeradataImportCommand'
            };
            result.importSettings.additionalFormatOptions = Array.isArray(model.importSettings.additionalFormatOptions)
                ? toParameterObject(model.importSettings.additionalFormatOptions)
                : ValueAdapter.toResource(model.importSettings, ImportExportSettings.ADDITIONAL_FORMATOPTIONS);
        }
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.TeradataSink, owner: Activity): Promise<TeradataSink> {
        const result = Owned.create<TeradataSink>(this.model(), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        if (resource.importSettings != null) {
            result.importSettings = Owned.create<ImportExportSettings>(
                ImportExportSettings.MODEL,
                result
            );
            if (
                resource.importSettings.additionalFormatOptions &&
                typeof resource.importSettings.additionalFormatOptions === 'object' &&
                resource.importSettings.additionalFormatOptions.type !== 'Expression'
            ) {
                result.importSettings.additionalFormatOptions = toParameterClass(
                    resource.importSettings.additionalFormatOptions,
                    result.importSettings
                );
            } else {
                ValueAdapter.toModel(
                    result.importSettings,
                    ImportExportSettings.ADDITIONAL_FORMATOPTIONS,
                    resource.importSettings.additionalFormatOptions
                );
            }
        }
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
